import React, { useEffect, useState, useRef } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";

import img1 from '../../Assests_Url/Ulearn_12th/Enhance Keywords/1 Tap the highlighted Keyword.png'
import img2 from '../../Assests_Url/Ulearn_12th/Enhance Keywords/2 View the additional information in the left side pane.png'
import img3 from '../../Assests_Url/Ulearn_12th/Enhance Keywords/3 Tap another keyword.png'
import img4 from '../../Assests_Url/Ulearn_12th/Enhance Keywords/4 View the additional information.png'

import img11 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/1. Concept Video within base book.png'
import img12 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/2.Both base book and Concept video.png'
import img13 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/3. Explanation Video within base book.png'
import img14 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/4. Filteration of Metaconten.png'
import img15 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/5.Unit  or chapter selection.png'
import img16 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/6. Resource Selection.png'
import img17 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/7. Search result.png'
import img18 from '../../Assests_Url/Ulearn_12th/Explanation & Concept videos/8. Searched  concept video.png'

import img21 from '../../Assests_Url/Ulearn_12th/3D Model/1.Go to a 3D model ex. Embryo Sac.png'
import img22 from '../../Assests_Url/Ulearn_12th/3D Model/2.Rotate the 3D model to view 360 degrees.png'

import img31 from '../../Assests_Url/Ulearn_12th/2D animation/1.2D Animation.png'
import img32 from '../../Assests_Url/Ulearn_12th/2D animation/2.Basebook and 2D Animation.png'
import img33 from '../../Assests_Url/Ulearn_12th/2D animation/3.Full screen view.png'

import img41 from '../../Assests_Url/Ulearn_12th/virtual lab/1. Go to a session with Virtual experiment and open it 1.jpg'
import img42 from '../../Assests_Url/Ulearn_12th/virtual lab/2. Go to a session with Virtual experiment and open it 2.jpg'
import img43 from '../../Assests_Url/Ulearn_12th/virtual lab/3. Go to a session with Virtual experiment and open it 3.jpg'
import img44 from '../../Assests_Url/Ulearn_12th/virtual lab/4. View of Virtual experiment screen 1.jpg'
import img45 from '../../Assests_Url/Ulearn_12th/virtual lab/5. View of Virtual experiment screen 2.jpg'
import img46 from '../../Assests_Url/Ulearn_12th/virtual lab/6. View of Virtual experiment screen 3.jpg'
import img47 from '../../Assests_Url/Ulearn_12th/virtual lab/7. Details of Virtual experiment.jpg'
import img48 from '../../Assests_Url/Ulearn_12th/virtual lab/8. Virtual experiment - on selection materials 1.jpg'
import img49 from '../../Assests_Url/Ulearn_12th/virtual lab/9. Virtual experiment - instructions 2.jpg'
import img40 from '../../Assests_Url/Ulearn_12th/virtual lab/10. Virtual experiment - instructions 3.jpg'
import img411 from '../../Assests_Url/Ulearn_12th/virtual lab/11. Virtual experiment - instructions 4.jpg'

import img51 from '../../Assests_Url/Ulearn_12th/Interactive exercises/1 Fill in the blanks with audio input.png'
import img52 from '../../Assests_Url/Ulearn_12th/Interactive exercises/2 Tap mic icon - say the answer then Check.png'
import img53 from '../../Assests_Url/Ulearn_12th/Interactive exercises/3 Type the answer then Check.png'

import img61 from '../../Assests_Url/Ulearn_12th/INTERACTIVE QUIZZ/1. Chapter wise Self- Assessment.png'
import img62 from '../../Assests_Url/Ulearn_12th/INTERACTIVE QUIZZ/2. Student answer and correct answer.png'
import img63 from '../../Assests_Url/Ulearn_12th/INTERACTIVE QUIZZ/3. Student answer.png'

import img71 from '../../Assests_Url/Ulearn_12th/study material/1. Study material - View.jpg'
import img72 from '../../Assests_Url/Ulearn_12th/study material/2. Study material - View.jpg'

import img81 from '../../Assests_Url/Ulearn_12th/Audio Reader Button/1 Open a Unit.png'
import img82 from '../../Assests_Url/Ulearn_12th/Audio Reader Button/2 Open a Session.png'
import img83 from '../../Assests_Url/Ulearn_12th/Audio Reader Button/3 Select a paragraph and tap Listen Audio button Tap Play button from the Listen Audio tools - to.png'
import img84 from '../../Assests_Url/Ulearn_12th/Audio Reader Button/4 view highlighted words.png'

import img91 from '../../Assests_Url/Ulearn_12th/Personalization/1. Tap on Notes in the menu on selection of a text.jpg'
import img92 from '../../Assests_Url/Ulearn_12th/Personalization/2. Notes - Select color  and submit (2).jpg'
import img93 from '../../Assests_Url/Ulearn_12th/Personalization/3.Notes - icon and content view.jpg'
import img94 from '../../Assests_Url/Ulearn_12th/Personalization/4. Notes - Listed.jpg'
import img95 from '../../Assests_Url/Ulearn_12th/Personalization/5.Book mark - add content and save.jpg'
import img96 from '../../Assests_Url/Ulearn_12th/Personalization/6. Bookmark - Save and  listing.jpg'
import img97 from '../../Assests_Url/Ulearn_12th/Personalization/7.Bookmark - listing.jpg'
import img98 from '../../Assests_Url/Ulearn_12th/Personalization/8 Bookmark - access from top menu.jpg'

import img101 from '../../Assests_Url/Ulearn_12th/Dictionary and translate/1. Inbuilt Dictionary.jpg'
import img102 from '../../Assests_Url/Ulearn_12th/Dictionary and translate/2.  Dictionary View.jpg'
import img103 from '../../Assests_Url/Ulearn_12th/Dictionary and translate/3. Dictionary.jpg'
import img104 from '../../Assests_Url/Ulearn_12th/Dictionary and translate/4.Inbuilt Translator.jpg'
import img105 from '../../Assests_Url/Ulearn_12th/Dictionary and translate/5. Language seletion.jpg'

import iimg1 from '../../Assests_Url/Ulearn_12th/AI Search/1 Select a text and tap AI Search from the menu.png'
import iimg2 from '../../Assests_Url/Ulearn_12th/AI Search/2 Select Summary.png'
import iimg3 from '../../Assests_Url/Ulearn_12th/AI Search/3 Select the AI preferred.png'
import iimg4 from '../../Assests_Url/Ulearn_12th/AI Search/4 Submit the request.png'
import iimg5 from '../../Assests_Url/Ulearn_12th/AI Search/5 Summary generated.png'
import iimg6 from '../../Assests_Url/Ulearn_12th/AI Search/6 Select Synopsis.png'
import iimg7 from '../../Assests_Url/Ulearn_12th/AI Search/7 Select AI preferred.png'
import iimg8 from '../../Assests_Url/Ulearn_12th/AI Search/8 Synopsis generated.png'
import iimg9 from '../../Assests_Url/Ulearn_12th/AI Search/9 Change the AI to get synopsis from that AI.png'
import iimg10 from '../../Assests_Url/Ulearn_12th/AI Search/10 AI Search - select ChatGPT.png'
import iimg11 from '../../Assests_Url/Ulearn_12th/AI Search/11 View the results from ChatGPT.png'
import iimg12 from '../../Assests_Url/Ulearn_12th/AI Search/12 Select Encyclopedia from the menu.png'
import iimg13 from '../../Assests_Url/Ulearn_12th/AI Search/13 Select Wikipedia.png'
import iimg14 from '../../Assests_Url/Ulearn_12th/AI Search/14 View the search results from Wikipedia.png'
import iimg15 from '../../Assests_Url/Ulearn_12th/AI Search/15 Select Translate from the menu.png'
import iimg16 from '../../Assests_Url/Ulearn_12th/AI Search/16 Select MS Transalator from the menu.png'
import iimg17 from '../../Assests_Url/Ulearn_12th/AI Search/17 Select the language  Tamil - View the result.png'
import iimg18 from '../../Assests_Url/Ulearn_12th/AI Search/18 Select the language  Hindi - View the result.png'

import iimg21 from '../../Assests_Url/Ulearn_12th/COVERAGE REPORT/1.After using the KATBOOK.jpg'
import iimg22 from '../../Assests_Url/Ulearn_12th/COVERAGE REPORT/1.Before using the KATBOOK.jpg'
import iimg23 from '../../Assests_Url/Ulearn_12th/COVERAGE REPORT/COVERAGE REPORT - Still001.jpg'
import iimg24 from '../../Assests_Url/Ulearn_12th/COVERAGE REPORT/COVERAGE REPORT - Still002.jpg'
import iimg25 from '../../Assests_Url/Ulearn_12th/COVERAGE REPORT/COVERAGE REPORT - Still003.jpg'

import iimg31 from '../../Assests_Url/Ulearn_12th/Try it your self/1.TRY it Yourself within base book.jpg'
import iimg32 from '../../Assests_Url/Ulearn_12th/Try it your self/2. Inbuilt coding environment.jpg'
import iimg33 from '../../Assests_Url/Ulearn_12th/Try it your self/3. Students can write, run, and test programs.jpg'
import iimg34 from '../../Assests_Url/Ulearn_12th/Try it your self/4. Program Output.jpg'

import iimg41 from '../../Assests_Url/Ulearn_12th/multi search/1.Text selection.jpg'
import iimg42 from '../../Assests_Url/Ulearn_12th/multi search/2.Search engine selection.jpg'
import iimg43 from '../../Assests_Url/Ulearn_12th/multi search/3. Bing search result.jpg'
import iimg44 from '../../Assests_Url/Ulearn_12th/multi search/4. Enclopedia search result.jpg'
import iimg45 from '../../Assests_Url/Ulearn_12th/multi search/5. britanica search result.jpg'

import { IoArrowUndoCircle, IoColorWandOutline } from "react-icons/io5";
import { PiVideoFill } from "react-icons/pi";
import { MdOutline3DRotation } from "react-icons/md";
import mic from "../../Assests_Url/2d.png";
import vl from "../../Assests_Url/virtual_labs.png";
import iex from "../../Assests_Url/Inter_exer.png";
import { MdAssignment } from "react-icons/md";
import { BiSolidBook } from "react-icons/bi";
import { RiVolumeUpFill } from "react-icons/ri";
import pers from "../../Assests_Url/gridicons.png";
import { FaLanguage } from "react-icons/fa6";
import aisearch from "../../Assests_Url/ai.png";
import coverage from "../../Assests_Url/cov-report.png";
import mul_search from "../../Assests_Url/multi-search.png";
import { VscBook } from "react-icons/vsc";
import { useLocation, useNavigate } from "react-router-dom";

import Carousel from "../Carousel/Carousel";

const ULearnStandard = ({ RoutesClick, NcertClick, selectedLang, setSelectedLang, allCountries }) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const v1 = useRef(null);
  const v2 = useRef(null);
  const v3 = useRef(null);
  const v4 = useRef(null);
  const v5 = useRef(null);
  const v6 = useRef(null);
  const v7 = useRef(null);
  const v8 = useRef(null);
  const v9 = useRef(null);
  const v10 = useRef(null);
  const v11 = useRef(null);
  const v12 = useRef(null);
  const v13 = useRef(null);
  const v14 = useRef(null);
  const v15 = useRef(null);

  const pauseOthers = (current) => {
    [v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15].forEach((ref) => {
      if (ref.current && ref.current !== current) {
        ref.current.pause();
      }
    });
  };

  const sampleData1 = [
    {
      img: img1,
      title: "Tap the highlighted Keyword",
    },
    {
      img: img2,
      title: "View the additional information in the left side pane",
    },
    {
      img: img3,
      title: "Tap another keyword",
    },
    {
      img: img4,
      title: "View the additional information",
    }
  ];

  const sampleData2 = [
    {
      img: img11,
      title: "Concept Video within base book",
    },
    {
      img: img12,
      title: "Both base book and Concept video",
    },
    {
      img: img13,
      title: "Explanation Video within base book",
    },
    {
      img: img14,
      title: "Filteration of Meta content",
    },
    {
      img: img15,
      title: "Unit or chapter selection",
    },
    {
      img: img16,
      title: "Resource Selection",
    },
    {
      img: img17,
      title: "Search result",
    },
    {
      img: img18,
      title: "Searched concept video",
    }
  ];

  const sampleData3 = [
    {
      img: img21,
      title: "Go to a 3D model ex. Embryo Sac",
    },
    {
      img: img22,
      title: "Rotate the 3D model to view 360 degrees",
    }
  ];

  const sampleData4 = [
    {
      img: img31,
      title: "2D Animation",
    },
    {
      img: img32,
      title: "Basebook and 2D Animation",
    },
    {
      img: img33,
      title: "Full screen view",
    }
  ];

  const sampleData5 = [
    {
      img: img41,
      title: "Go to a session with Virtual experiment and open it 1",
    },
    {
      img: img42,
      title: "Go to a session with Virtual experiment and open it 2",
    },
    {
      img: img43,
      title: "Go to a session with Virtual experiment and open it 3",
    },
    {
      img: img44,
      title: "View of Virtual experiment screen 1",
    },
    {
      img: img45,
      title: "View of Virtual experiment screen 2",
    },
    {
      img: img46,
      title: "View of Virtual experiment screen 3",
    },
    {
      img: img47,
      title: "Details of Virtual experiment",
    },
    {
      img: img48,
      title: "Virtual experiment - on selection materials 1",
    },
    {
      img: img49,
      title: "Virtual experiment - instructions 2",
    },
    {
      img: img40,
      title: "Virtual experiment - instructions 3",
    },
    {
      img: img411,
      title: "Virtual experiment - instructions 4",
    },
  ];

  const sampleData6 = [
    {
      img: img51,
      title: "Fill in the blanks with audio input",
    },
    {
      img: img52,
      title: "Tap mic icon - say the answer then Check",
    },
    {
      img: img53,
      title: "Type the answer then Check",
    }
  ];

  const sampleData7 = [
    {
      img: img61,
      title: "Chapter wise Self- Assessment",
    },
    {
      img: img62,
      title: "Student answer and correct answer",
    },
    {
      img: img63,
      title: "Student answer",
    }
  ];

  const sampleData8 = [
    {
      img: img71,
      title: "Study Material - View",
    },
    {
      img: img72,
      title: "Study Material - View",
    }
  ];

  const sampleData9 = [
    {
      img: img81,
      title: "Open a Unit",
    },
    {
      img: img82,
      title: "Open a Session",
    },
    {
      img: img83,
      title: "Select a paragraph and tap Listen Audio button Tap Play button from the Listen Audio tools - to",
    },
    {
      img: img84,
      title: "View highlighted words",
    }
  ];

  const sampleData10 = [
    {
      img: img91,
      title: "Tap on Notes in the menu on selection of a text",
    },
    {
      img: img92,
      title: "Notes - Select color and submit",
    },
    {
      img: img93,
      title: "Notes - icon and content view",
    },
    {
      img: img94,
      title: "Notes - Listed",
    },
    {
      img: img95,
      title: "Bookmark - add content and save",
    },
    {
      img: img96,
      title: "Bookmark - Save and listing",
    },
    {
      img: img97,
      title: "Bookmark - listing",
    },
    {
      img: img98,
      title: "Bookmark - access from top menu",
    },
  ];

  const sampleData11 = [
    {
      img: img101,
      title: "Inbuilt Dictionary",
    },
    {
      img: img102,
      title: "Dictionary View",
    },
    {
      img: img103,
      title: "Dictionary",
    },
    {
      img: img104,
      title: "Inbuilt Translator",
    },
    {
      img: img105,
      title: "Language seletion",
    }
  ];

  const sampleData12 = [
    {
      img: iimg1,
      title: "Select a text and tap AI Search from the menu",
    },
    {
      img: iimg2,
      title: "Select Summary",
    },
    {
      img: iimg3,
      title: "Select the AI preferred",
    },
    {
      img: iimg4,
      title: "Submit the request",
    },
    {
      img: iimg5,
      title: "Summary generated",
    },
    {
      img: iimg6,
      title: "Select Synopsis",
    },
    {
      img: iimg7,
      title: "Select AI preferred",
    },
    {
      img: iimg8,
      title: "Synopsis generated",
    },
    {
      img: iimg9,
      title: "Change the AI to get synopsis from that AI",
    },
    {
      img: iimg10,
      title: "AI Search - select ChatGPT",
    },
    {
      img: iimg11,
      title: "View the results from ChatGPT",
    },
    {
      img: iimg12,
      title: "Select Encyclopedia from the menu",
    },
    {
      img: iimg13,
      title: "Select Wikipedia",
    },
    {
      img: iimg14,
      title: "View the search results from Wikipedia",
    },
    {
      img: iimg15,
      title: "Select Translate from the menu",
    },
    {
      img: iimg16,
      title: "Select MS Transalator from the menu",
    },
    {
      img: iimg17,
      title: "Select the language  Tamil - View the result",
    },
    {
      img: iimg18,
      title: "Select the language  Hindi - View the result",
    }
  ];

  const sampleData13 = [
    {
      img: iimg21,
      title: "After using the KATBOOK",
    },
    {
      img: iimg22,
      title: "Before using the KATBOOK",
    },
    {
      img: iimg23,
      title: "COVERAGE REPORT - Still 1",
    },
    {
      img: iimg24,
      title: "COVERAGE REPORT - Still 2",
    },
    {
      img: iimg25,
      title: "COVERAGE REPORT - Still 3",
    }
  ];

  const sampleData14 = [
    {
      img: iimg41,
      title: "Text selection",
    },
    {
      img: iimg42,
      title: "Search engine selection",
    },
    {
      img: iimg43,
      title: "Bing search result",
    },
    {
      img: iimg44,
      title: "Enclopedia search result",
    },
    {
      img: iimg45,
      title: "britanica search result",
    }
  ];

  const sampleData15 = [
    {
      img: iimg31,
      title: "TRY it Yourself within base book",
    },
    {
      img: iimg32,
      title: "Inbuilt coding environment",
    },
    {
      img: iimg33,
      title: "Students can write, run, and test programs",
    },
    {
      img: iimg34,
      title: "Program Output",
    }
  ];

  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          AdminregisterModal={AdminregisterModal}
          setAdminregisterModal={setAdminregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
          allCountries={allCountries}
        />
      </div>

      <div className="container-uteach">
        <div className="pt-5">
          <div className="d-flex align-items-center justify-content-between text-center pb-4">
            <div>
              <IoArrowUndoCircle
                size={30}
                className="back-arrow"
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className="found-font">
              {lang === "en"
                ? "ULearn Higher Standard Books"
                : lang === "hi"
                  ? "यूलर्न उच्चतर मानक पुस्तकें"
                  : null
              }
            </div>
            <div></div>
          </div>

          <div className="text-foun-font text-center py-3">
            {/* KATBOOK enhances the learning experience for secondary and senior
            secondary levels by combining NCERT/CBSE-aligned content with
            advanced digital learning aids. */}
            {lang === "en"
              ? "KATBOOK enhances the learning experience for secondary and senior secondary levels by combining NCERT/CBSE-aligned content with advanced digital learning aids."
              : lang === "hi"
                ? "कैटबुक, एनसीईआरटी/सीबीएसई-संरेखित सामग्री को उन्नत डिजिटल शिक्षण सहायक सामग्री के साथ जोड़कर माध्यमिक और उच्चतर माध्यमिक स्तर के लिए सीखने के अनुभव को बेहतर बनाती है।"
                : null
            }
          </div>

          <div className="d-flex flex-column align-items-center gap-3 pt-3">
            <div className="meta-font">
              {/* The Power of Meta Content */}
              {lang === "en"
                ? "The Power of Meta Content"
                : lang === "hi"
                  ? "मेटा सामग्री की शक्ति"
                  : null
              }
            </div>
            <div className="text-foun-font text-center">
              {/* NCERT KATBOOKS for higher classes are powered with
              state-of-the-art learning resources curated by subject experts and
              global content creators. */}
              {lang === "en"
                ? "NCERT KATBOOKS for higher classes are powered with state-of-the-art learning resources curated by subject experts and global content creators."
                : lang === "hi"
                  ? "उच्च कक्षाओं के लिए एनसीईआरटी कैटबुक, विषय विशेषज्ञों और वैश्विक सामग्री निर्माताओं द्वारा तैयार किए गए अत्याधुनिक शिक्षण संसाधनों से संचालित हैं।"
                  : null
              }
            </div>
            <div className="text-foun-font text-center">
              {/* Students can use these advanced digital resources to understand
              complex concepts in science, mathematics, computer science, and
              more with greater clarity. */}
              {lang === "en"
                ? "Students can use these advanced digital resources to understand complex concepts in science, mathematics, computer science, and more with greater clarity."
                : lang === "hi"
                  ? "छात्र इन उन्नत डिजिटल संसाधनों का उपयोग विज्ञान, गणित, कंप्यूटर विज्ञान आदि में जटिल अवधारणाओं को अधिक स्पष्टता के साथ समझने के लिए कर सकते हैं।"
                  : null
              }
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 1. Enhanced Keywords{" "} */}
                    {lang === "en"
                      ? "1. Enhanced Keywords "
                      : lang === "hi"
                        ? "1. उन्नत कीवर्ड "
                        : null
                    }
                    <IoColorWandOutline size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Important terms, formulae, and concepts are highlighted as
                    keywords. Students can click on them to open a side-by-side
                    screen showing definitions, explanations, derivations, and
                    related references. */}
                    {lang === "en"
                      ? "Important terms, formulae, and concepts are highlighted as keywords. Students can click on them to open a side-by-side screen showing definitions, explanations, derivations, and related references."
                      : lang === "hi"
                        ? "महत्वपूर्ण शब्द, सूत्र और अवधारणाएँ कीवर्ड के रूप में हाइलाइट की गई हैं। छात्र उन पर क्लिक करके एक साथ-साथ स्क्रीन खोल सकते हैं जिसमें परिभाषाएँ, स्पष्टीकरण, व्युत्पत्तियाँ और संबंधित संदर्भ दिखाई देते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Acts as a quick reference during study. */}
                        {lang === "en"
                          ? "Acts as a quick reference during study."
                          : lang === "hi"
                            ? "अध्ययन के दौरान त्वरित संदर्भ के रूप में कार्य करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Ensures consistent and standardised understanding of key
                        terms. */}
                        {lang === "en"
                          ? "Ensures consistent and standardised understanding of key terms."
                          : lang === "hi"
                            ? "प्रमुख शब्दों की सुसंगत एवं मानकीकृत समझ सुनिश्चित करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData1} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v1} className="video-css" width="540" controls onPlay={() => pauseOthers(v1.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986256490303488_EnhanceKeyword12thS1.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 2. Concept & Explanation Videos (Embedded){" "} */}
                    {lang === "en"
                      ? "2. Concept & Explanation Videos (Embedded) "
                      : lang === "hi"
                        ? "2. अवधारणा और व्याख्या वीडियो (एम्बेडेड) "
                        : null
                    }
                    <PiVideoFill size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Concept & Explanation Videos are embedded within the KATBOOK
                    to explain difficult or abstract concepts. Students can
                    play, pause, and watch these videos directly without leaving
                    the KATBOOK window. */}
                    {lang === "en"
                      ? "Concept & Explanation Videos are embedded within the KATBOOK to explain difficult or abstract concepts. Students can play, pause, and watch these videos directly without leaving the KATBOOK window."
                      : lang === "hi"
                        ? "कठिन या अमूर्त अवधारणाओं को समझाने के लिए अवधारणा और व्याख्या वीडियो KATBOOK में एम्बेड किए गए हैं। छात्र KATBOOK विंडो को छोड़े बिना सीधे इन वीडियो को चला सकते हैं, रोक सकते हैं और देख सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Provides instant support and saves time by removing the
                        need to search for external sources. */}
                        {lang === "en"
                          ? "Provides instant support and saves time by removing the need to search for external sources."
                          : lang === "hi"
                            ? "यह तत्काल सहायता प्रदान करता है और बाहरी स्रोतों की खोज करने की आवश्यकता को समाप्त करके समय की बचत करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Helps standardise understanding across all students. */}
                        {lang === "en"
                          ? "Helps standardise understanding across all students."
                          : lang === "hi"
                            ? "यह सभी छात्रों की समझ को मानकीकृत करने में मदद करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData2} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v2} className="video-css" width="540" controls onPlay={() => pauseOthers(v2.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986289080045568_ExplanationConceptvideos12thS2.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 3. 3D Models & Activities{" "} */}
                    {lang === "en"
                      ? "3. 3D Models & Activities "
                      : lang === "hi"
                        ? "3. 3D मॉडल और गतिविधियाँ "
                        : null
                    }
                    <MdOutline3DRotation size={"20px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Interactive 3D models of molecules, body systems, geometric
                    structures, and lab apparatus are available within the
                    KATBOOK. Students can rotate, zoom, and explore them. */}
                    {lang === "en"
                      ? "Interactive 3D models of molecules, body systems, geometric structures, and lab apparatus are available within the KATBOOK. Students can rotate, zoom, and explore them."
                      : lang === "hi"
                        ? "अणुओं, शरीर प्रणालियों, ज्यामितीय संरचनाओं और प्रयोगशाला उपकरणों के इंटरैक्टिव 3D मॉडल KATBOOK में उपलब्ध हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Improves understanding of abstract diagrams and
                        scientific structures. */}
                        {lang === "en"
                          ? "Improves understanding of abstract diagrams and scientific structures."
                          : lang === "hi"
                            ? "अमूर्त आरेखों और वैज्ञानिक संरचनाओं की समझ में सुधार करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Makes complex concepts tangible and interactive. */}
                        {lang === "en"
                          ? "Makes complex concepts tangible and interactive."
                          : lang === "hi"
                            ? "जटिल अवधारणाओं को टेंजिबल और इंटरैक्टिव बनाता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData3} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v3} className="video-css" width="540" controls onPlay={() => pauseOthers(v3.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986332461731840_3DModel12thS3.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 4. 2D Animations{" "} */}
                    {lang === "en"
                      ? "4. 2D Animations "
                      : lang === "hi"
                        ? "4. 2D एनिमेशन "
                        : null
                    }
                    <img src={mic} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Step-by-step animations illustrate processes such as
                    chemical reactions, biological functions, physical laws, and
                    more. */}
                    {lang === "en"
                      ? "Step-by-step animations illustrate processes such as chemical reactions, biological functions, physical laws, and more."
                      : lang === "hi"
                        ? "चरण-दर-चरण एनिमेशन रासायनिक प्रतिक्रियाओं, जैविक कार्यों, भौतिक नियमों आदि जैसी प्रक्रियाओं को दर्शाते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Simplifies difficult concepts into clear visual
                        sequences. */}
                        {lang === "en"
                          ? "Simplifies difficult concepts into clear visual sequences."
                          : lang === "hi"
                            ? "कठिन अवधारणाओं को स्पष्ट दृश्य अनुक्रमों में सरलीकृत करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Helps students learn processes systematically. */}
                        {lang === "en"
                          ? "Helps students learn processes systematically."
                          : lang === "hi"
                            ? "छात्रों को प्रक्रियाओं को व्यवस्थित रूप से सीखने में मदद करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData4} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v4} className="video-css" width="540" controls onPlay={() => pauseOthers(v4.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986332063272960_2DAnimation12thS4.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 5. Virtual Labs{" "} */}
                    {lang === "en"
                      ? "5. Virtual Labs "
                      : lang === "hi"
                        ? "5. वर्चुअल लैब "
                        : null
                    }
                    <img src={vl} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Fully simulated laboratory experiments with a step-by-step
                    interactive methodology are available in Physics, Chemistry,
                    and Biology. Students can perform these experiments
                    digitally. */}
                    {lang === "en"
                      ? "Fully simulated laboratory experiments with a step-by-step interactive methodology are available in Physics, Chemistry and Biology. Students can perform these experiments digitally."
                      : lang === "hi"
                        ? "भौतिकी, रसायन विज्ञान और जीव विज्ञान में चरण-दर-चरण इंटरैक्टिव पद्धति के साथ पूरी तरह से सिम्युलेटेड प्रयोगशाला प्रयोग उपलब्ध हैं। छात्र इन प्रयोगों को डिजिटल रूप से कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Provides repeatable and cost-effective practice. */}
                        {lang === "en"
                          ? "Provides repeatable and cost-effective practice."
                          : lang === "hi"
                            ? "दोहराए जाने योग्य और लागत प्रभावी अभ्यास प्रदान करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Ensures practical learning continues even without
                        physical labs. */}
                        {lang === "en"
                          ? "Ensures practical learning continues even without physical labs."
                          : lang === "hi"
                            ? "यह सुनिश्चित करता है कि भौतिक प्रयोगशालाओं के बिना भी व्यावहारिक शिक्षा जारी रहे।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData5} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v5} className="video-css" width="540" controls onPlay={() => pauseOthers(v5.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758985953602834432_VirtualLab12thS5.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 6. Interactive Exercises{" "} */}
                    {lang === "en"
                      ? "6. Interactive Exercises "
                      : lang === "hi"
                        ? "6. इंटरैक्टिव अभ्यास "
                        : null
                    }
                    <img src={iex} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Session-based interactive activities such as classification,
                    drag-and-drop, and application-based problem-solving
                    exercises are included. Students can solve these activities
                    on their own. */}
                    {lang === "en"
                      ? "Session-based interactive activities such as classification, drag-and-drop, and application-based problem-solving exercises are included. Students can solve these activities on their own."
                      : lang === "hi"
                        ? "सत्र-आधारित इंटरैक्टिव गतिविधियाँ जैसे वर्गीकरण, ड्रैग-एंड-ड्रॉप और अनुप्रयोग-आधारित समस्या-समाधान अभ्यास शामिल हैं। छात्र इन गतिविधियों को स्वयं हल कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Promotes higher-order thinking and application of
                        concepts. */}
                        {lang === "en"
                          ? "Promotes higher-order thinking and application of concepts."
                          : lang === "hi"
                            ? "उच्च-स्तरीय सोच और अवधारणाओं के अनुप्रयोग को बढ़ावा देता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Makes learning engaging and participative. */}
                        {lang === "en"
                          ? "Makes learning engaging and participative."
                          : lang === "hi"
                            ? "सीखने को आकर्षक और सहभागी बनाता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData6} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v6} className="video-css" width="540" controls onPlay={() => pauseOthers(v6.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986313792884736_Interactiveexrcise12thS6.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 7. Assessments in KATBOOK{" "} */}
                    {lang === "en"
                      ? "7. Assessments in KATBOOK "
                      : lang === "hi"
                        ? "7. KATBOOK में मूल्यांकन "
                        : null
                    }
                    <MdAssignment size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* KATBOOK includes a wide range of built-in assessments —
                    multiple choice, fill-in-the-blanks, and short or long
                    answer formats. */}
                    {lang === "en"
                      ? "KATBOOK includes a wide range of built-in assessments — multiple choice, fill-in-the-blanks, and short or long answer formats."
                      : lang === "hi"
                        ? "KATBOOK में अंतर्निहित मूल्यांकनों की एक विस्तृत श्रृंखला शामिल है - बहुविकल्पीय, रिक्त स्थान भरें, और लघु या दीर्घ उत्तर प्रारूप।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Students can attempt assessments to test their knowledge
                        instantly. */}
                        {lang === "en"
                          ? "Students can attempt assessments to test their knowledge instantly."
                          : lang === "hi"
                            ? "छात्र अपने ज्ञान का परीक्षण करने के लिए तुरन्त मूल्यांकन का प्रयास कर सकते हैं।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Keeps learning exciting and interactive. */}
                        {lang === "en"
                          ? "Keeps learning exciting and interactive."
                          : lang === "hi"
                            ? "यह सीखने को रोमांचक और इंटरैक्टिव बनाता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData7} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v7} className="video-css" width="540" controls onPlay={() => pauseOthers(v7.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986377403699200_AssessmentKatbook12thS7.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 8. Study Material with Q&A Bank (with Solutions){" "} */}
                    {lang === "en"
                      ? "8. Study Material with Q&A Bank (with Solutions) "
                      : lang === "hi"
                        ? "8. प्रश्नोत्तर बैंक सहित अध्ययन सामग्री (समाधान सहित) "
                        : null
                    }
                    <BiSolidBook size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Comprehensive study material including solved examples,
                    model answers, and a Q&A bank aligned with board exam
                    patterns is available. */}
                    {lang === "en"
                      ? "Comprehensive study material including solved examples, model answers, and a Q&A bank aligned with board exam patterns is available."
                      : lang === "hi"
                        ? "समग्र अध्ययन सामग्री जिसमें हल किए गए उदाहरण, मॉडल उत्तर और बोर्ड परीक्षा पैटर्न से संबंधित प्रश्नोत्तर बैंक शामिल हैं, उपलब्ध है।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Provides exam-focused preparation support. */}
                        {lang === "en"
                          ? "Provides exam-focused preparation support."
                          : lang === "hi"
                            ? "परीक्षा-केंद्रित तैयारी सहायता प्रदान करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Offers standardized practice material without needing
                        extra resources. */}
                        {lang === "en"
                          ? "Offers standardized practice material without needing extra resources."
                          : lang === "hi"
                            ? "अतिरिक्त संसाधनों की आवश्यकता के बिना मानकीकृत अभ्यास सामग्री प्रदान करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData8} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v8} className="video-css" width="540" controls onPlay={() => pauseOthers(v8.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986108863385600_Studymaterial12thS8.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-center gap-3 pt-5">
            <div className="meta-font">
              {/* INTERACTIVE FEATURES OF KATBOOK */}
              {lang === "en"
                ? "INTERACTIVE FEATURES OF KATBOOK"
                : lang === "hi"
                  ? "कैटबुक की इंटरैक्टिव विशेषताएँ"
                  : null
              }
            </div>
            <div className="text-foun-font text-center">
              {/* Higher Standards KATBOOKS are equipped with interactive features
              that support independent learning, simplify revision, and provide
              advanced digital tools for exam readiness. */}
              {lang === "en"
                ? "Higher Standards KATBOOKS are equipped with interactive features that support independent learning, simplify revision, and provide advanced digital tools for exam readiness."
                : lang === "hi"
                  ? "उच्च मानक कैटबुक इंटरैक्टिव विशेषताओं से सुसज्जित हैं जो स्वतंत्र शिक्षण का समर्थन करती हैं, पुनरावृत्ति को सरल बनाती हैं और परीक्षा की तैयारी के लिए उन्नत डिजिटल उपकरण प्रदान करती हैं।"
                  : null
              }
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 1. Audio Reader Button{" "} */}
                    {lang === "en"
                      ? "1. Audio Reader Button "
                      : lang === "hi"
                        ? "1. ऑडियो रीडर बटन "
                        : null
                    }
                    <RiVolumeUpFill size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Students can play the entire session or select passages
                    using the Audio Reader Button for instant audio playback. */}
                    {lang === "en"
                      ? "Students can play the entire session or select passages using the Audio Reader Button for instant audio playback."
                      : lang === "hi"
                        ? "छात्र तत्काल ऑडियो प्लेबैक के लिए ऑडियो रीडर बटन का उपयोग करके पूरा सत्र चला सकते हैं या अंश चुन सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Improves pronunciation, fluency, and clarity in language
                        subjects. */}
                        {lang === "en"
                          ? "Improves pronunciation, fluency, and clarity in language subjects."
                          : lang === "hi"
                            ? "भाषा विषयों में उच्चारण, प्रवाह और स्पष्टता में सुधार करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Supports auditory learning and comprehension. */}
                        {lang === "en"
                          ? "Supports auditory learning and comprehension."
                          : lang === "hi"
                            ? "श्रवण सीखने और समझने में सहायता करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData9} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v9} className="video-css" width="540" controls onPlay={() => pauseOthers(v9.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986377588248576_AudioReader12thS9.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 2. Personalisation{" "} */}
                    {lang === "en"
                      ? "2. Personalisation "
                      : lang === "hi"
                        ? "2. निजीकरण "
                        : null
                    }
                    <img src={pers} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Students can highlight important passages, create digital
                    notes, and bookmark chapters within KATBOOK. All
                    personalized inputs remain saved for future reference. */}
                    {lang === "en"
                      ? "Students can highlight important passages, create digital notes, and bookmark chapters within KATBOOK. All personalized inputs remain saved for future reference."
                      : lang === "hi"
                        ? "छात्र KATBOOK के भीतर महत्वपूर्ण अंशों को हाइलाइट कर सकते हैं, डिजिटल नोट्स बना सकते हैं और अध्यायों को बुकमार्क कर सकते हैं। सभी व्यक्तिगत इनपुट भविष्य के संदर्भ के लिए सहेजे जाते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Functions as a digital study diary. */}
                        {lang === "en"
                          ? "Functions as a digital study diary."
                          : lang === "hi"
                            ? "यह एक डिजिटल अध्ययन डायरी के रूप में कार्य करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Simplifies revision and improves learning organization. */}
                        {lang === "en"
                          ? "Simplifies revision and improves learning organization."
                          : lang === "hi"
                            ? "पुनरावृत्ति को सरल बनाता है और शिक्षण व्यवस्था में सुधार करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData10} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v10} className="video-css" width="540" controls onPlay={() => pauseOthers(v10.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986037988036608_PERSONALISATION12thS10.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 3. Inbuilt Dictionary & Translator{" "} */}
                    {lang === "en"
                      ? "3. Inbuilt Dictionary & Translator "
                      : lang === "hi"
                        ? "3. अंतर्निहित शब्दकोश और अनुवादक "
                        : null
                    }
                    <FaLanguage size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Students can highlight any word or passage to view meanings
                    and synonyms. The built-in translator allows entire passages
                    or words to be translated into regional or preferred
                    languages. */}
                    {lang === "en"
                      ? "Students can highlight any word or passage to view meanings and synonyms. The built-in translator allows entire passages or words to be translated into regional or preferred languages."
                      : lang === "hi"
                        ? "छात्र किसी भी शब्द या अंश को हाइलाइट करके उसके अर्थ और समानार्थी शब्द देख सकते हैं। अंतर्निहित अनुवादक संपूर्ण अंशों या शब्दों को क्षेत्रीय या पसंदीदा भाषाओं में अनुवादित करने की अनुमति देता है।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Enhances comprehension and vocabulary. */}
                        {lang === "en"
                          ? "Enhances comprehension and vocabulary."
                          : lang === "hi"
                            ? "समझ और शब्दावली को बढ़ाता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Removes the need for external dictionary or translation
                        apps. */}
                        {lang === "en"
                          ? "Removes the need for external dictionary or translation apps."
                          : lang === "hi"
                            ? "बाहरी शब्दकोश या अनुवाद ऐप्स की आवश्यकता को समाप्त करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData11} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v11} className="video-css" width="540" controls onPlay={() => pauseOthers(v11.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986229411876864_DictionaryTranslate12thS11.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 4. AI Search{" "} */}
                    {lang === "en"
                      ? "4. AI Search "
                      : lang === "hi"
                        ? "4. एआई सर्च "
                        : null
                    }
                    <img src={aisearch} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* By highlighting text, students can activate AI Search to
                    instantly generate summaries, derivations, explanations, or
                    even Q&A for that section. */}
                    {lang === "en"
                      ? "By highlighting text, students can activate AI Search to instantly generate summaries, derivations, explanations, or even Q&A for that section."
                      : lang === "hi"
                        ? "पाठ को हाइलाइट करके, छात्र उस अनुभाग के लिए तुरंत सारांश, व्युत्पत्ति, स्पष्टीकरण या यहाँ तक कि प्रश्नोत्तर उत्पन्न करने के लिए एआई सर्च को सक्रिय कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Provides quick and reliable supplementary material. */}
                        {lang === "en"
                          ? "Provides quick and reliable supplementary material."
                          : lang === "hi"
                            ? "त्वरित एवं विश्वसनीय अनुपूरक सामग्री उपलब्ध कराता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Helps in deeper understanding and exam preparation. */}
                        {lang === "en"
                          ? "Helps in deeper understanding and exam preparation."
                          : lang === "hi"
                            ? "गहन समझ और परीक्षा की तैयारी में मदद करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData12} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v12} className="video-css" width="540" controls onPlay={() => pauseOthers(v12.current)}>
                      {/* <source src={video12} type="video/mp4" /> */}
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986358432862208_AISearch12thS12.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 5. Coverage Report{" "} */}
                    {lang === "en"
                      ? "5. Coverage Report "
                      : lang === "hi"
                        ? "5. कवरेज रिपोर्ट "
                        : null
                    }
                    <img src={coverage} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* When connected with KAMPUS during school-wide rollout,
                    students can track their progress — chapters covered,
                    activities completed, and assessments attempted. */}
                    {lang === "en"
                      ? "When connected with KAMPUS during school-wide rollout, students can track their progress — chapters covered, activities completed, and assessments attempted."
                      : lang === "hi"
                        ? "स्कूल-व्यापी रोलआउट के दौरान KAMPUS से जुड़ने पर, छात्र अपनी प्रगति पर नज़र रख सकते हैं—पढ़े गए अध्याय, पूरी की गई गतिविधियाँ और किए गए आकलन।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Helps monitor personal progress. */}
                        {lang === "en"
                          ? "Helps monitor personal progress."
                          : lang === "hi"
                            ? "व्यक्तिगत प्रगति पर नजर रखने में मदद करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Helps parents to also see the book coverage report */}
                        {lang === "en"
                          ? "Helps parents to also see the book coverage report"
                          : lang === "hi"
                            ? "अभिभावकों को पुस्तक कवरेज रिपोर्ट देखने में भी मदद करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData13} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v13} className="video-css" width="540" controls onPlay={() => pauseOthers(v13.current)}>
                      {/* <source src={video13} type="video/mp4" /> */}
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986229210550272_COVERAGEREPORT12thS13.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 6. Multiple Search{" "} */}
                    {lang === "en"
                      ? "6. Multiple Search "
                      : lang === "hi"
                        ? "6. बहु-खोज "
                        : null
                    }
                    <img src={mul_search} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Students can highlight and select any word or part of the
                    text from KATBOOK and explore multiple sources for
                    information, including: */}
                    {lang === "en"
                      ? "Students can highlight and select any word or part of the text from KATBOOK and explore multiple sources for information, including: "
                      : lang === "hi"
                        ? "छात्र KATBOOK से किसी भी शब्द या पाठ के किसी भाग को हाइलाइट और चुन सकते हैं और जानकारी के लिए कई स्रोतों का पता लगा सकते हैं, जिनमें शामिल हैं: "
                        : null
                    }
                    <ul>
                      <li>
                        {/* AI tools like ChatGPT, Perplexity and more */}
                        {lang === "en"
                          ? "AI tools like ChatGPT, Perplexity and more "
                          : lang === "hi"
                            ? "चैटजीपीटी, पेरप्लेक्सिटी जैसे एआई उपकरण और अन्य "
                            : null
                        }
                      </li>
                      <li>
                        {/* Web browsers */}
                        {lang === "en"
                          ? "Web browsers"
                          : lang === "hi"
                            ? "वेब ब्राउज़र"
                            : null
                        }
                      </li>
                      <li>
                        {/* Encyclopedias such as Wikipedia, Britannica and more */}
                        {lang === "en"
                          ? "Encyclopedias such as Wikipedia, Britannica and more"
                          : lang === "hi"
                            ? "विकिपीडिया, ब्रिटानिका जैसे विश्वकोश और अन्य"
                            : null
                        }
                      </li>
                      <li>
                        {/* Dictionaries like Merriam-Webster or Oxford */}
                        {lang === "en"
                          ? "Dictionaries like Merriam-Webster or Oxford"
                          : lang === "hi"
                            ? "मेरियम-वेबस्टर या ऑक्सफ़ोर्ड जैसे शब्दकोश"
                            : null
                        }
                      </li>
                      {/* This feature allows students to go beyond the textbook and
                      explore subjects more deeply. */}
                      {lang === "en"
                        ? "This feature allows students to go beyond the textbook and explore subjects more deeply."
                        : lang === "hi"
                          ? "यह सुविधा छात्रों को पाठ्यपुस्तक से आगे जाकर विषयों का अधिक गहराई से अन्वेषण करने की अनुमति देती है। "
                          : null
                      }
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData14} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v14} className="video-css" width="540" controls onPlay={() => pauseOthers(v14.current)}>
                      {/* <source src={video14} type="video/mp4" /> */}
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/758986188748099584_Multiplesearch12thS14.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    {/* 7. “Try it Yourself” in Computer Science Books{" "} */}
                    {lang === "en"
                      ? "7. “Try it Yourself” in Computer Science Books "
                      : lang === "hi"
                        ? "7. कंप्यूटर विज्ञान की पुस्तकों में “स्वयं प्रयास करें”"
                        : null
                    }
                    <VscBook size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {/* Computer Science KATBOOKS have an inbuilt coding environment
                    where students can write, run, and test programs directly. */}
                    {lang === "en"
                      ? "Computer Science KATBOOKS have an inbuilt coding environment where students can write, run, and test programs directly."
                      : lang === "hi"
                        ? "कंप्यूटर विज्ञान की कैटबुक्स में एक अंतर्निहित कोडिंग वातावरण होता है जहाँ छात्र सीधे प्रोग्राम लिख, चला और परीक्षण कर सकते हैं।"
                        : null
                    }
                    <ul>
                      <li>
                        {/* Encourages hands-on programming practice. */}
                        {lang === "en"
                          ? "Encourages hands-on programming practice."
                          : lang === "hi"
                            ? "यह व्यावहारिक प्रोग्रामिंग अभ्यास को प्रोत्साहित करता है।"
                            : null
                        }
                      </li>
                      <li>
                        {/* Strengthens computational thinking and problem-solving
                        skills. */}
                        {lang === "en"
                          ? "Strengthens computational thinking and problem-solving skills."
                          : lang === "hi"
                            ? "कम्प्यूटेशनल सोच और समस्या-समाधान कौशल को मज़बूत करता है।"
                            : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData15} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video ref={v15} className="video-css" width="540" controls onPlay={() => pauseOthers(v15.current)}>
                      <source src={"https://cdn.katbook.com/assets/sites/ncert/760434046760259584_Tryityourself.mp4"} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-start gap-3 pt-5 pb-3">
            <div className="meta-font">
              {/* STUDENT BENEFITS */}
              {lang === "en"
                ? "STUDENT BENEFITS"
                : lang === "hi"
                  ? "छात्रों के लिए लाभ"
                  : null
              }
            </div>
            <div className="cont-para">
              <ul>
                <li>
                  {/* Provides advanced digital resources for clearer understanding. */}
                  {lang === "en"
                    ? "Provides advanced digital resources for clearer understanding."
                    : lang === "hi"
                      ? "स्पष्ट समझ के लिए उन्नत डिजिटल संसाधन प्रदान करता है।"
                      : null
                  }
                </li>
                <li>
                  {/* Encourages interactive, self-directed, and exam-focused study. */}
                  {lang === "en"
                    ? "Encourages interactive, self-directed, and exam-focused study."
                    : lang === "hi"
                      ? "इंटरैक्टिव, स्व-निर्देशित और परीक्षा-केंद्रित अध्ययन को प्रोत्साहित करता है।"
                      : null
                  }
                </li>
                <li>
                  {/* Builds critical thinking, application, and problem-solving
                  skills. */}
                  {lang === "en"
                    ? "Builds critical thinking, application, and problem-solving skills."
                    : lang === "hi"
                      ? "आलोचनात्मक सोच, अनुप्रयोग और समस्या समाधान कौशल का निर्माण करता है।"
                      : null
                  }
                </li>
                <li>
                  {/* Tracks progress and ensures students stay on top of their
                  learning. */}
                  {lang === "en"
                    ? "Tracks progress and ensures students stay on top of their learning."
                    : lang === "hi"
                      ? "प्रगति पर नज़र रखता है और सुनिश्चित करता है कि छात्र अपनी शिक्षा में अग्रणी बने रहें।"
                      : null
                  }
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  );
};

export default ULearnStandard;
